var URI = {
    init: function () {
        var wh = window.location.href;
        var ac = wh.split('#/');

        if (typeof ac[1] === 'undefined') {
            var no = wh.split('/');
            if (!no[3]) {
                var no = no[3].split('?');
                if (no[0] != 'noticia') {
                    window.location.href = '/#/home';
                }
            }
        } else {
            URI.exec(ac[1]);
            URI.selectMenu(ac[1]);
        }
    },

    change: function () {
        var wh = window.location.href;
        var ac = wh.split('#/');

        var dd = ac[1].split('/');

        if (typeof ac[1] !== 'undefined') {
            $('.site-navbar-nav li.active').removeClass('active');
            URI.selectMenu(ac[1]);
            URI.exec(ac[1]);
            $('.navbar-collapse').collapse('hide');
        }
    },

    exec: function (ac, title = undefined) {
        if (typeof title != 'undefined') document.title = window.changetitle;

        $('#content').html('').addClass('content-loading');
        $.post('/load', { action: ac }, function (r) {
            $('#content').html(r).removeClass('content-loading');
        });
    },

    selectMenu: function (ac) {
        var dd = ac.split('/');

        if ($('#li-' + dd[0]).length > 0) $('#li-' + dd[0]).addClass('active');
    },
};

window.onhashchange = function () {
    URI.change();
    $('body, html').animate({ scrollTop: 0 }, 900);
};
